import Styled from 'styled-components';

const LoadingWrapper = Styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000000;
`;

const PageWrapper = Styled.div`
    position: relative;
    min-height: 100vh;
`;

const ContentBodyWrapper = Styled.div`
    position: relative;
    // padding-left: 8px;
    // padding-right: 8px;
`;

export { LoadingWrapper, PageWrapper, ContentBodyWrapper };
